// extracted by mini-css-extract-plugin
var _1 = "CurrentPlanCard_flexColumn__oci49";
var _2 = "CurrentPlanCard_price__Qm8SK";
var _3 = "CurrentPlanCard_wrapper__abWdk";
export { _1 as "flexColumn", _2 as "price", _3 as "wrapper" }
